import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Tag } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';
import PipelineSteps from './PipelineSteps';
import styles from './ActiveDeploymentCard.module.scss';

function useElapsed(demarreLe) {
    const [elapsed, setElapsed] = useState('0 s');

    useEffect(() => {
        if (!demarreLe) return undefined;
        const tick = () => {
            const seconds = Math.max(0, moment().diff(moment(demarreLe), 'seconds'));
            const m = Math.floor(seconds / 60);
            const s = seconds % 60;
            setElapsed(m > 0 ? `${m} min ${String(s).padStart(2, '0')}` : `${s} s`);
        };
        tick();
        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
    }, [demarreLe]);

    return elapsed;
}

export default function ActiveDeploymentCard({ deploiement, environnements, onViewDetails }) {
    const elapsed = useElapsed(deploiement?.demarre_le);

    if (!deploiement) return null;

    const cibles = deploiement.cibles ?? [];

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <div className={styles.liveBadge}>
                    <span className={styles.dot} />
                    EN DIRECT
                </div>
                <div className={styles.title}>Déploiement en cours</div>
                <div className={styles.elapsed}>{elapsed}</div>
                <Button
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => onViewDetails(deploiement.uid)}
                    className={styles.detailBtn}
                >
                    Détail complet
                </Button>
            </div>

            <div className={styles.targets}>
                {cibles.map((code) => {
                    const cibleData = deploiement.resultat?.[code];
                    const label = environnements.find((e) => e.code === code)?.label ?? code;
                    return (
                        <div key={code} className={styles.target}>
                            <div className={styles.targetHeader}>
                                <span className={styles.targetLabel}>{label}</span>
                                <Tag color={cibleData?.statut === 'succes' ? 'success' : cibleData?.statut === 'echec' ? 'error' : 'processing'}>
                                    {cibleData?.statut === 'succes' ? 'Succès' : cibleData?.statut === 'echec' ? 'Échec' : 'En cours'}
                                </Tag>
                            </div>
                            <PipelineSteps steps={cibleData?.steps} compact />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

ActiveDeploymentCard.propTypes = {
    deploiement: PropTypes.shape({
        uid: PropTypes.string,
        cibles: PropTypes.array,
        resultat: PropTypes.object,
        demarre_le: PropTypes.string,
    }),
    environnements: PropTypes.array.isRequired,
    onViewDetails: PropTypes.func.isRequired,
};
